export const appointmentTypes = {
  getAppointmentTypes,
  getAppointmentType,
};

const appointmentTypeList = [
  {
    appointmentTypeID: 1, //IID Install
    serviceID: 0,
    Name: "Installation",
    DisplayName: "Installation IID",
    ESDisplayName: "Instalación",
    Image: "./src/_images/install_fff.png",
    Description: "Let our expert technicians get you back on the road.",
    ESDescription:
      "Deje que nuestros técnicos expertos lo ayuden a volver a la carretera.",
    deviceType: "IID",
  },
  {
    appointmentTypeID: 2,
    serviceID: 0,
    Name: "Monitoring",
    DisplayName: "IID Monitoring",
    ESDisplayName: "Escucha",
    Image: "./src/_images/monitoring_fff.png",
    Description:
      "Standard service appointment for your device to perform optimally.",
    ESDescription:
      "Cita de servicio estándar para que su dispositivo funcione de manera óptima.",
    deviceType: "IID",
  },
  {
    appointmentTypeID: 3,
    serviceID: 0,
    Name: "Lock Out",
    DisplayName: "IID Lock Out",
    ESDisplayName: "Dejar Fuera",
    Image: "./src/_images/lock_out_fff.png",
    Description:
      "Have our service technicians help you reset the lock out mode on your device.",
    ESDescription:
      "Pida a nuestros técnicos de servicio que le ayuden a restablecer el modo de bloqueo en su dispositivo.",
    deviceType: "IID",
  },
  // {
  //   appointmentTypeID: 4,
  //   serviceID: 0,
  //   Name: "Vehicle Swap",
  //   DisplayName: "Vehicle Swap",
  //   ESDisplayName: "Interruptor de Vehículo",
  //   Image: "./src/_images/Maintenance_fff.png",
  //   Description:
  //     "Have our service technicians move your device from one vehicle to another.",
  //   ESDescription: "Haga que nuestros técnicos de servicio muevan su dispositivo de un vehículo a otro.",
  // },
  {
    appointmentTypeID: 5,
    serviceID: 0,
    Name: "Deinstall",
    DisplayName: "Deinstall IID",
    ESDisplayName: "Desinstalar",
    Image: "./src/_images/Handshake_fff.png",
    Description:
      "Finish up the process with the deinstallation of your LifeSafer device.",
    ESDescription:
      "Finalice el proceso con la desinstalación de su dispositivo LifeSafer.",
    deviceType: "IID",
  },
  {
    appointmentTypeID: 6, //PAM Install
    serviceID: 0,
    Name: "Installation",
    DisplayName: "PAM Installation",
    ESDisplayName: "Instalación",
    Image: "./src/_images/install_fff.png",
    Description: "Let our expert technicians get you back on the road.",
    ESDescription:
      "Deje que nuestros técnicos expertos lo ayuden a volver a la carretera.",
    deviceType: "PAM",
  },
  {
    appointmentTypeID: 7,
    serviceID: 0,
    Name: "Monitoring",
    DisplayName: "PAM Monitoring",
    ESDisplayName: "Escucha",
    Image: "./src/_images/pam_monitoring_fff.png",
    Description:
      "Standard service appointment for your device to perform optimally.",
    ESDescription:
      "Cita de servicio estándar para que su dispositivo funcione de manera óptima.",
    deviceType: "PAM",
  },
  {
    appointmentTypeID: 8,
    serviceID: 0,
    Name: "Device Return",
    DisplayName: "PAM Device Return",
    ESDisplayName: "Devolución del Dispositivo",
    Image: "./src/_images/Handshake_fff.png",
    Description:
      "Finish up the process with the deinstallation of your LifeSafer device.",
    ESDescription:
      "Finalice el proceso con la desinstalación de su dispositivo LifeSafer.",
    deviceType: "PAM",
  },
  // ISA
  {
    appointmentTypeID: 9,
    serviceID: 0,
    Name: "Installation",
    DisplayName: "ISA Installation",
    ESDisplayName: "Devolución del Dispositivo",
    Image: "./src/_images/install_fff.png",
    Description: "Let our expert technicians get you back on the road.",
    ESDescription:
      "Deje que nuestros técnicos expertos lo ayuden a volver a la carretera.",
    deviceType: "ISA",
  },

  {
    appointmentTypeID: 10,
    serviceID: 0,
    Name: "Monitoring",
    DisplayName: "ISA Monitoring",
    ESDisplayName: "Devolución del Dispositivo",
    Image: "./src/_images/monitoring_fff.png",
     Description:
      "Standard service appointment for your device to perform optimally.",
    ESDescription:
      "Cita de servicio estándar para que su dispositivo funcione de manera óptima.",
    deviceType: "ISA",
  },

  {
    appointmentTypeID: 11,
    serviceID: 0,
    Name: "Deinstall",
    DisplayName: "ISA Removal",
    ESDisplayName: "Devolución del Dispositivo",
    Image: "./src/_images/Handshake_fff.png",
    Description:
      "Finish up the process with the deinstallation of your LifeSafer device.",
    ESDescription:
      "Finalice el proceso con la desinstalación de su dispositivo LifeSafer.",
    deviceType: "ISA",
  },
];

function getAppointmentTypes() {
  return appointmentTypeList;
}

function getAppointmentType(aptTypeID) {
  return appointmentTypeList.find((x) => x.appointmentTypeID === aptTypeID);
}
